import { Injectable } from '@angular/core';
import { AppEnum } from '../appenum';
import { AppService } from './app.service';
import { EncryptionService } from './encryption.service';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  public ifconnected: any;
  level = this._appenum.EntityOfLogLevel.All;
  logWithDate: boolean = true;
  ifConnected: any;
  deviceInfo: any;

  constructor(
    public _appservice: AppService,
    public _appenum: AppEnum,
    public encryptionService: EncryptionService,
    private deviceService: DeviceDetectorService,
  ) { }

  private shouldLog(level: any): boolean {
    let ret: boolean = false;
    if (
      (level >= this.level && level !== this._appenum.EntityOfLogLevel.Off) ||
      this.level === this._appenum.EntityOfLogLevel.All
    ) {
      ret = true;
    }
    return ret;
  }

  async handleResponseLog(
    severity: 'info' | 'warning' | 'critical' | 'error',
    logRequest: any,
    StatusCode: any,
    Message: any,
    logMessage: any,
    componentName: any,
    // response?: any,
    apiName?: any
  ) {
    const logLevel =
      severity === 'critical'
        ? this._appenum.EntityOfLogLevel.Critical
        : severity === 'warning'
          ? this._appenum.EntityOfLogLevel.Warning
          : severity === 'info'
            ? this._appenum.EntityOfLogLevel.Info
            : this._appenum.EntityOfLogLevel.Error;
    logRequest.response = { responseCode: StatusCode, responseMsg: Message };
    console.log("apiName", apiName)
    await this.apilogs(
      logLevel,
      logMessage,
      componentName,
      logRequest,
      apiName
    );
  }

  async logApiError(
    severity: 'info' | 'warning' | 'critical' | 'error',
    logRequest: any,
    error: any,
    logMessage: any,
    componentName: any,
    apiName?: string,
  ) {
    const logLevel =
      severity === 'critical'
        ? this._appenum.EntityOfLogLevel.Critical
        : severity === 'warning'
          ? this._appenum.EntityOfLogLevel.Warning
          : severity === 'info'
            ? this._appenum.EntityOfLogLevel.Info
            : this._appenum.EntityOfLogLevel.Error;
    logRequest.error = { result: error };
    // covers 'error' and default/nothing

    await this.apilogs(
      logLevel,
      logMessage,
      componentName,
      logRequest,
      apiName
    );
  }

  async logFunctionError(
    error: any,
    functionName: string,
    componentName: any,
    context?: any
  ): Promise<void> {

    const serializedError = error instanceof Error
      ? {
        message: error.message,
        name: error.name,
        stack: error.stack,
      }
      : error;
    const logPayload = {
      function: functionName,
      error: { result: serializedError },
      ...(context !== undefined && { context })
    };

    await this.apilogs(
      this._appenum.EntityOfLogLevel.Error,
      `Functional Error in ${functionName}()`,
      componentName,
      logPayload,
      undefined,
      functionName
    );
  }

  async apilogs(severity, logTextMsg, componentOrPage, logRequestResponse, apiName?: any, functionName?: string) {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const ua = navigator.userAgent;
    if (this.deviceInfo.os === 'iOS' || /iPhone|iPad|iPod/.test(ua)) {
      // iOS — UA string is reliable, no Client Hints exist here at all
      this.deviceInfo.os_version = this._appservice.parseIOSVersion(ua);
      this.deviceInfo.model = this._appservice.parseIOSModel(ua);

    } else if ('userAgentData' in navigator) {
      // Android Chromium browsers — use Client Hints for real data
      try {
        const uaData = (navigator as any).userAgentData;
        const high = await uaData.getHighEntropyValues(['platformVersion', 'model']);
        this.deviceInfo.os_version = high.platformVersion || 'unknown';
        this.deviceInfo.model = high.model || 'unknown';
      } catch (e) {
        console.warn('Client Hints failed', e);
        this.deviceInfo.os_version = this._appservice.parseAndroidVersion(ua);
        this.deviceInfo.model = this._appservice.parseAndroidModel(ua);
      }
    } else {
      // Android Firefox, or any non-Chromium browser
      this.deviceInfo.os_version = this._appservice.parseAndroidVersion(ua);
      this.deviceInfo.model = this._appservice.parseAndroidModel(ua);
    }
    if (this.shouldLog(severity)) {
      const agentId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentid)) || null;
      const sessionId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) || null;
      const deviceId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) || null;
      const deviceInfo = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) : JSON.stringify(this.deviceInfo)
      const postJson = {
        severity: this._appenum.EntityOfLogLevel[severity], //"info/error/warning/critical/",
        logTextMsg: logTextMsg,
        logtime: new Date().toISOString(),
        userId: agentId,
        sessionId: sessionId,
        deviceId: deviceId,
        deviceInfo: deviceInfo,
        componentOrPage: componentOrPage,
        operationMode: 'Assisted PWA',
        logRequestResponseError: logRequestResponse,
        taskId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskid)),
        ...(apiName ? { apiName } : {}),
        ...(functionName ? { functionName } : {}),
      };
      var postArray = [];
      postArray.push(postJson);
      var res = {
        data: postArray,
      };
      console.log("payload of logs", res)
      try {
        await this._appservice.postDataWithPromiseWithoutAuth(environment.endpoint.directLogging, res).then((res) => {
        });
      } catch (error) {
        console.error('Error posting log data:', error);
      }
    }
  }

  async PermissionLogs(
    severity: 'info' | 'warning' | 'critical' | 'error',
    logMessage: any,
    componentName: any,
  ) {
    const logLevel =
      severity === 'critical'
        ? this._appenum.EntityOfLogLevel.Critical
        : severity === 'warning'
          ? this._appenum.EntityOfLogLevel.Warning
          : severity === 'info'
            ? this._appenum.EntityOfLogLevel.Info
            : this._appenum.EntityOfLogLevel.Error;
    // covers 'error' and default/nothing

    await this.apilogs(
      logLevel,
      logMessage,
      componentName,
      undefined,
    );
  }

  async cameraPermissionLogs(
    severity: 'info' | 'warning' | 'critical' | 'error',
    logMessage: any,
    componentName: any,
  ) {
    const logLevel =
      severity === 'critical'
        ? this._appenum.EntityOfLogLevel.Critical
        : severity === 'warning'
          ? this._appenum.EntityOfLogLevel.Warning
          : severity === 'info'
            ? this._appenum.EntityOfLogLevel.Info
            : this._appenum.EntityOfLogLevel.Error;
    // covers 'error' and default/nothing

    await this.apilogs(
      logLevel,
      logMessage,
      componentName,
      undefined,
    );
  }
  async handleCustomCameraLogs(logspayload) {
    await this.apilogs(
      this._appenum.EntityOfLogLevel.Info,
      'Custom Camera Logs',
      'Custom-Camera',
      logspayload
    );
  }

}
